import Alert from "@mui/material/Alert";
import { ServerErrorCommon } from "../../common/components/ServerErrorCommon";
import { Footer } from "../../footer/components/Footer";
import { Header } from "../../header/components/Header";
import { useScheduledLogout } from "../../common/hooks/useScheduledLogout";
import { isExistsLogin } from "../../common/miscellaneous/handleCookies";
import { AppRoutes } from "./AppRoutes";
import { Container } from "./Container";

function App() {
  const { showWarningBanner } = useScheduledLogout();

  return (
    <>
      <Header />
      {showWarningBanner && isExistsLogin() && (
        <Alert severity="warning" sx={{ borderRadius: 0, justifyContent: "center" }}>
          Just a reminder: You'll be logged out at midnight. Please finish your current task and save your changes to avoid losing any work. Thank you.
        </Alert>
      )}
      <Container>
        <AppRoutes />
        <ServerErrorCommon />
      </Container>
      <Footer />
    </>
  );
}

export default App;
